export const EVENT_SLIDERS = {
  CREATE_STRIPE_ACCOUNT: 'create-stripe-account',
  CREATE_STRIPE_CREDIT_NOTE: 'create-stripe-credit-note',
  CREATE_PARTIAL_CREDIT_NOTE: 'create-partial-credit-note',
  UPDATE_INVOICE_STATUS: 'update-invoice-status',
  CREATE_CREDIT_NOTE: 'create-credit-note',
  CREATE_STRIPE_INVOICE: 'create-stripe-invoice',
  CREATE_STRIPE_PAYMENT: 'create-stripe-payment',
  INFOS_STRIPE_INVOICES: 'infos-stripe-invoices',
  MODIFY_SUBSCRIPTION: 'modify-subscription',
  EDIT_AMOUNT_ADAF: 'edit-amount-adaf',
  EDIT_SUBSCRIPTION_ADAF: 'edit-subscription-adaf',
  PAYMENT_REMINDER: 'payment-reminder',
};

export const SHOW_UBIQ_ADMINISTRATION_SLIDER = 'ubiq-administration-action-show';
